import { Database, ref, set } from 'firebase/database';

export const daysOffUpdate = async (
	database: Database,
	daysOff: string[]
): Promise<void> => {
	return set(ref(database, `settings/daysOff`), daysOff);
};
